import React from 'react';
import { DsTag } from '@tokenyico/design-system/dist/reactJS';
import { humanizeString } from 'app/helpers/humanizeString';

export const InvestorStatusBadge = ({ status, ...rest }) => {
  const versions = {
    Qualified: 'success',
    Registered: 'warning',
    TokenHolder: 'info',
    Failed: 'error',
    Revoked: 'error',
    Unknown: 'default',
    InProgress: 'warning',
  };

  return (
    <DsTag
      label={humanizeString(status) || '-'}
      version={versions[status] || 'default'}
      icon="profile-card"
      iconSize="13px"
      size="xs"
      {...rest}
    />
  );
};
